export const OS_OPTIONS = [
  { label: 'Windows', value: 'Windows' },
];

export const CPU_ARCHITECTURE_OPTIONS = [
  { label: 'x64', value: 'x64' },
  { label: 'arm64', value: 'arm64' },
];

export const OS_ARCHITECTURES: Record<string, string[]> = {
  Windows: ['x64', 'arm64'],
};
